export type ScheduledReminder = {
  user_seq: number;
  run_at_utc: string | null | undefined;
};

/** Sort scheduled reminders newest first, leaving invalid/missing dates at the end. */
export function compareReminderTimesNewestFirst(a: ScheduledReminder, b: ScheduledReminder): number {
  const aTime = a.run_at_utc ? Date.parse(a.run_at_utc) : Number.NaN;
  const bTime = b.run_at_utc ? Date.parse(b.run_at_utc) : Number.NaN;

  if (Number.isNaN(aTime)) return Number.isNaN(bTime) ? 0 : 1;
  if (Number.isNaN(bTime)) return -1;
  return bTime - aTime;
}

/** Sort overdue reminders by distance from now: most recently overdue first. */
export const compareOverdueNearestFirst = compareReminderTimesNewestFirst;
